export const createPushNotification = (payload: any) => ({
    type: "@saga/CREATE_PUSH_NOTIFICATION",
    payload
});
